// CID Agent PWA API layer
// Module: Team & Branch performance (downline production, branch production for Centre Directors)
//
// The client names a SCOPE — 'direct' | 'team' | 'branch' — and never an agent id.
// The server resolves which agents that means from the caller's downline and their
// Centre-Director branch assignments; anything outside it is a 403, not an empty list.
import client from './client';

/**
 * GET /api/agent/performance/scopes
 * Which scopes this caller holds → { can: { direct, allGens, branch }, counts, branches[] }.
 * Cheap, and the gate for every entry point: no scopes, no Team-performance card.
 */
export const getPerformanceScopes = () => client.get('/api/agent/performance/scopes');

/**
 * GET /api/agent/performance/summary?scope=&branch_id=&from=&to=
 * Hero + KPI tiles + pipeline funnel in one response, so the top of the screen
 * paints in a single round trip.
 */
export const getPerformanceSummary = (params = {}) => client.get('/api/agent/performance/summary', { params });

/**
 * GET /api/agent/performance/members [LIST · paginated]
 * The leaderboard: one row per agent in scope with period GCI, volume, deals,
 * open pipeline and dormancy. ?sort=gci|deals|volume|name|pipeline &q= &include_inactive=
 */
export const listPerformanceMembers = (params = {}, config = {}) =>
  client.get('/api/agent/performance/members', { params, ...config });

/**
 * GET /api/agent/performance/members/:agentId?from=&to=
 * Drill-down sheet payload. Override attribution is present only when the member is
 * in the caller's own downline.
 */
export const getPerformanceMember = (agentId, params = {}) =>
  client.get(`/api/agent/performance/members/${agentId}`, { params });

/**
 * GET /api/agent/performance/deals [LIST · paginated]
 * Deals in scope. ?state=closed|pipeline &agent_id= &stage_group=DRAFT|INVOICE|CLAIM|HQ
 * Trimmed shape — production facts only, no counterparties, and no link into the
 * sale record (that route is ownership-guarded and would 403).
 */
export const listPerformanceDeals = (params = {}, config = {}) =>
  client.get('/api/agent/performance/deals', { params, ...config });

/**
 * GET /api/agent/performance/attention?scope=&branch_id=
 * The exception queue: stuck deals, dormant agents, and — branch scope only — REN
 * expiries inside 60 days.
 */
export const listPerformanceAttention = (params = {}) =>
  client.get('/api/agent/performance/attention', { params });
